import React from 'react';
import { translate  } from 'react-i18next';
import { Row, Col, FormGroup, Label, Input, Button } from 'reactstrap';
import {observer} from 'mobx-react';
import TextField from '../Components/Form/TextField';


@observer
class PromoCodeSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkingVoucher: false,
    };
  }


  applyPromo = () => {
    this.setState({
      checkingVoucher: true
    });

    this.props.booking.applyDiscounts().then(() => {
      this.setState({
        invalidPromo: !this.props.booking.promo_code.id,
        checkingVoucher: false
      });
    });
  };

  removePromoCode = () => {
    this.props.booking.removePromoCode();
  };

  render() {
    const { t, booking } = this.props;

    return (
    	<div>
        <Row>
          <Col xs="12">
            <TextField
              type="text"
              disabled={this.state.checkingVoucher || booking.promo_code.id}
              name="promo_code"
              error={this.state.invalidPromo}
              errorText={t('Invalid promo code')}
              value={booking.promo_code.code}
              onChange={(e) => booking.promo_code.code = e.target.value}
              label={t('Promo code')}
            />
          </Col>
          <Col xs="12">
            {
              !booking.promo_code.id &&
              <Button
                block
                color="secondary"
                size="md"
                disabled={this.state.checkingVoucher || booking.promo_code.code === ''}
                onClick={this.applyPromo}
              >
                {this.state.checkingVoucher ? t('Checking promo code') : t('Apply promo code')}
              </Button> ||
              <Button
                block
                color="warning"
                size="md"
                onClick={this.removePromoCode}
              >
                {t('Remove code')}
              </Button>
            }
          </Col>
        </Row>
      </div>
    );
  }
};

export default translate ()(PromoCodeSection);



// WEBPACK FOOTER //
// ./src/App/Checkout/PromoCodeSection.js